import day from "../../assets/day.svg"
import cloudyDay1 from '../../assets/cloudy-day-1.svg'
import cloudy from '../../assets/cloudy.svg'
import cloudyDay3 from '../../assets/cloudy-day-3.svg'
import rainy6 from '../../assets/rainy-6.svg'
import snowy5 from '../../assets/snowy-5.svg'
import rainy7 from '../../assets/rainy-7.svg'
import rainy1 from '../../assets/rainy-1.svg'
import snowy1 from '../../assets/snowy-1.svg'
import thunder from '../../assets/thunder.svg'



export const codeTemps = [
    
{      
       code:0,
       temps:'Soleil',
       image:day
   },{
       code:1,
       temps:'Peu nuageux',
       image:cloudyDay1
   },
    
    {  code:2,
       temps:'Ciel voilé',
       image:cloudy
   },
    
   {  code:3,
      temps:'Nuageux',
      image:cloudyDay3
   },
    
   {  code:4,
      temps:'Pluie',
      image:rainy6
   },     
    
   {  code:5,
      temps:'Neige',
      image:snowy5
   },
    
   {  code:6,
      temps:'Pluie et neige mêlées',
      image:rainy7
  },{  
     
     code:7,
     temps:'Averses de pluie',
     image:rainy1
 },{  
     
    code:8,
    temps:'Averses de neige',
    image:snowy1
},{  
    
   code:9,
   temps:'Orages',
   image:thunder
}]





